import { SearchReferenceDTO } from "entities/shared/shipmentCard.types";
import { Nullable } from "shared/lib/typeCheck.lib";

/** Query params for Qubictron tracking/v1/air (see main / API docs). */
export type AirQueryParams = {
  awb_number: SearchReferenceDTO;
  route_path?: Nullable<boolean>;
  signal?: AbortSignal;
};

/** @deprecated Use AirQueryParams */
export type SearchQueryParams = AirQueryParams;
